import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
import { COLLECTIONS } from "../../services/collections";

/**
 * CatalogService
 * Serviço para buscar itens do catálogo (Produtos e Serviços) do tenant.
 * Coleção: tenants/{idTenant}/services
 */
export const CatalogService = {
    /**
     * Lista itens do catálogo com filtros opcionais.
     * @param {string} idTenant - ID do tenant
     * @param {string} _idBranch - Reservado (não utilizado atualmente)
     * @param {Object} filters - Filtros: { type: 'product'|'service', isActive: boolean }
     * @returns {Promise<Array>} Lista de itens
     */
    listWithFilters: async (idTenant, _idBranch, filters = {}) => {
        if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

        try {
            // Busca todos os itens na coleção SERVICES (que concentra produtos e serviços)
            // Sem orderBy no query para evitar que documentos legados sem o campo sejam ignorados.
            const q = query(
                collection(db, "tenants", idTenant, COLLECTIONS.SERVICES)
            );

            const snapshot = await getDocs(q);
            let items = [];
            snapshot.forEach((doc) => {
                const data = doc.data();
                items.push({ 
                    id: doc.id, 
                    ...data,
                    name: data.nameService || data.name || "Sem Nome",
                    price: data.value || data.price || 0
                });
            });

            // Filtros em memória
            if (filters.type) {
                items = items.filter(item => item.type === filters.type);
            }
            if (filters.isActive !== undefined) {
                // No Firestore, o schema atual usa 'inactive' (booleano).
                // isActive: true => inactive deve ser falsy (false ou undefined)
                if (filters.isActive) {
                    items = items.filter(item => !item.inactive);
                } else {
                    items = items.filter(item => item.inactive === true);
                }
            }

            // Ordenação em memória usando 'nameService' ou o legado 'name'
            items.sort((a, b) => {
                const nameA = (a.nameService || a.name || "").toLowerCase();
                const nameB = (b.nameService || b.name || "").toLowerCase();
                return nameA.localeCompare(nameB);
            });

            return items;
        } catch (error) {
            console.error("[CatalogService] Erro ao listar itens:", error);
            throw error;
        }
    }
};
